import { render, staticRenderFns } from "./GroupUserItem.vue?vue&type=template&id=120856ef&scoped=true&"
import script from "./GroupUserItem.vue?vue&type=script&lang=ts&"
export * from "./GroupUserItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120856ef",
  null
  
)

export default component.exports